import z from "zod";

export const Theme = {
	light: "light",
	dark: "dark",
	system: "system",
} as const;

export type Theme = (typeof Theme)[keyof typeof Theme];
export const THEMES = Object.values(Theme) as readonly Theme[];
export const themeSchema = z.enum(THEMES);
